import create from "zustand";
import { Tabs } from "./constants";
import { ScenarioID } from "@modules/mgp-sso/types";

interface FinancialPlanState {
  selectedTab: Tabs;
  setSelectedTab: (tab: Tabs) => void;
  selectedScenario: ScenarioID;
  setSelectedScenario: (scenario: ScenarioID) => void;
}

const useStore = create<FinancialPlanState>((set) => ({
  selectedTab: Tabs.PlanOverview,
  setSelectedTab: (tab) => set({ selectedTab: tab }),
  selectedScenario: ScenarioID.Recommended,
  setSelectedScenario: (scenario) => set({ selectedScenario: scenario }),
}));

export default useStore;
